import * as React from "react";
import { ChakraProvider, Box, Heading, Text } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export function Careers() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("careers.metaTitle")}</title>
        <meta
          name="description"
          content={t("careers.metaDescription")}
        />
      </Helmet>

      <ChakraProvider>
        <Box
          pt={"20px"}
          pb={8}
          textAlign="justify"
          margin={"auto"}
          width="80%"
          maxWidth={"1100px"}
        >
          <Heading
            fontFamily={"Oswald"}
            fontWeight={500}
            fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
            lineHeight={"110%"}
            color={"gray.800"}
            textAlign={"center"}
            mt={"20px"}
            mb={2}
          >
            {t("careers.headingPrefix")}{" "}
            <Text as={"span"} color={"blue.500"}>
              {t("careers.headingEmphasis")}
            </Text>
          </Heading>
          <Box mt={3}>
            <Text
              textAlign="left"
              fontFamily={"Oswald"}
              fontWeight={500}
              color="blue.400"
              mb={2}
              mt={5}
            >
              {t("careers.sectionTitle")}
            </Text>
            <Text mb={6}>
              {t("careers.paragraphs.intro")}
            </Text>
            <Text mb={2}>
              {t("careers.paragraphs.cta")}
            </Text>
          </Box>
        </Box>
      </ChakraProvider>
    </>
  );
}

export default Careers;
